import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { PhotoswipeLightboxComponent } from '@df/ui/photoswipe/photoswipe-lightbox.component';
import { PhotoswipeDirective } from '@df/ui/photoswipe/photoswipe.directive';

@NgModule({
    imports: [CommonModule, PhotoswipeDirective, PhotoswipeLightboxComponent],
    exports: [PhotoswipeDirective, PhotoswipeLightboxComponent]
})
export class PhotoSwipeModule {}
